import React from "react";
import {defaultDeliveryProviderPricing, ImagesByCarType} from "./consts.jsx";
import {FormInputV2} from "../../../../components/form";
import {isEmpty} from "lodash";

export const columns = onChange => [
    {
        render: (_, {carType}) => <img alt="car-type" className="car-type-img" src={ImagesByCarType[carType]} />
    },
    {
        title: "מחיר בסיס",
        render: (_, {initialPrice}) => (
            <FormInputV2
                className="pricing-form-input"
                placeholder={defaultDeliveryProviderPricing.initialPrice}
                value={initialPrice}
                type="number"
                onChange={e =>
                    onChange(
                        "deliveryPricingSetting.initialPrice",
                        isEmpty(e.target.value) ? undefined : Number(e.target.value)
                    )
                }
            />
        )
    },
    {
        title: "לX ק״מ",
        render: (_, {unitDistance}) => (
            <FormInputV2
                className="pricing-form-input"
                placeholder={defaultDeliveryProviderPricing.unitDistance}
                value={unitDistance}
                type="number"
                onChange={e =>
                    onChange(
                        "deliveryPricingSetting.unitDistance",
                        isEmpty(e.target.value) ? undefined : Number(e.target.value)
                    )
                }
            />
        )
    },
    {
        render: _ => "+"
    },
    {
        title: "1 ק״מ נוסף",
        render: (_, {additionalPricePerUnitDistance}) => (
            <FormInputV2
                className="pricing-form-input"
                placeholder={defaultDeliveryProviderPricing.additionalPricePerUnitDistance}
                type="number"
                value={additionalPricePerUnitDistance}
                onChange={e =>
                    onChange(
                        "deliveryPricingSetting.additionalPricePerUnitDistance",
                        isEmpty(e.target.value) ? undefined : Number(e.target.value)
                    )
                }
            />
        )
    },
    {
        title: "מחיר לנקודה",
        render: (_, {homeDeliveryPrice}) => (
            <FormInputV2
                className="pricing-form-input"
                placeholder="מחיר לנקודה"
                type="number"
                value={homeDeliveryPrice}
                onChange={e =>
                    onChange("homeDeliveryPrice", isEmpty(e.target.value) ? undefined : Number(e.target.value))
                }
            />
        )
    },
    {
        title: "מחיר הזמנה מקסימלי",
        render: (_, {maxPrice}) => (
            <FormInputV2
                className="pricing-form-input-long"
                placeholder={defaultDeliveryProviderPricing.maxPrice}
                type="number"
                value={maxPrice}
                onChange={e =>
                    onChange(
                        "deliveryPricingSetting.maxPrice",
                        isEmpty(e.target.value) ? undefined : Number(e.target.value)
                    )
                }
            />
        )
    }
];
